import React from 'react';
import { useRouter } from "next/router";
import AnimationHeading from "src/components/AnimationsTags/AnimationHeading/AnimationHeading";
import AnimationParagraph from "src/components/AnimationsTags/AnimationParagraph/AnimationParagraph";
import parse from "html-react-parser";
import Image from "next/image";
import SparePartsImage from "public/assets/sections/services/spare_parts/spare_parts.jpeg";
import Overlay from "src/components/Overlay/Overlay";
import SparePartsLocales from "./locales/data";

const SpareParts = () => {
  const { locale } = useRouter();

  return (
    <section id="service-4" className="px-4 py-12 xl:py-20">
      <div className="container mx-auto flex flex-col xl:flex-row-reverse">
        <div className="w-full xl:w-2/4 pl-0 xl:pl-10">
          <AnimationHeading
            title={SparePartsLocales[locale].title}
            size="text-2xl xl:text-4xl"
            additionalStyle="lg:text-center uppercase tracking-wider"
            margin="pb-4 xl:pb-10"
          />
          <AnimationParagraph>
            {parse(SparePartsLocales[locale].content)}
          </AnimationParagraph>
        </div>
        <div className="w-full xl:w-2/4 mt-4 xl:mt-0 h-auto">
          <div className="relative w-full rounded-3xl overflow-hidden">
            <Image src={SparePartsImage} alt="" layout="responsive" objectFit="cover" />
            <Overlay opacity="bg-opacity-40" />
          </div>
        </div>
      </div>
    </section>
  );
};

export default SpareParts;